import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { useBarcode } from 'react-barcodes';
import ReactToPrint from 'react-to-print';
import { Button, Grid } from 'semantic-ui-react';
import { useStore } from '../../../stores/store';
import { userLanguage } from '../../userLanguageSchema/userLanguage';
interface Props {
  id: string;
  isScan?:boolean
}
function BarcodeGenerator({ id,isScan = true }: Props) {
  const { dashboardStore, commonStore } = useStore();
  const [itemId, setItemId] = useState('2342342423');
  const componentRef = useRef<HTMLDivElement>(null);
  // updating
  useEffect(() => {
    setItemId(id);
  }, [id]);

  useEffect(() => {
    if (dashboardStore.dashboard.getBarCodeValue !== '') {
      setItemId(dashboardStore.dashboard.getBarCodeValue);
    }
  }, [dashboardStore.dashboard.getBarCodeValue]);
  const { inputRef } = useBarcode({
    value: itemId,
    options: {
      displayValue: false,
      background: 'white',
    },
  });

  return (
    <>
      <div ref={componentRef} style={{ marginTop: '20px' }}>
        <Grid>
          <img
            ref={inputRef}
            src="https://www.grainmart.in/news/wp-content/uploads/2020/03/barcode-306926_960_720.png"
            alt=""
            style={{
              width: '250px',
              height: '110px',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>
        {!isScan && <span style={{fontSize:'11px',marginTop:'5px',display:'flex',justifyContent:'center'}}>{id}</span>}
      </div>
      {isScan && <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button.Group floated="right">
              <Button
                color="teal"
                onClick={() => dashboardStore.setOpenBarCodeScanner(true)}
                //Scan
              >
                {
                  (
                    userLanguage[0].Level3InventoryRecievingTag?.IRTB03 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
            </Button.Group>
          </Grid.Column>
          <Grid.Column>
            <ReactToPrint
              trigger={() => (
                <Button
                  variant="contained"
                  color="teal"
                  //Print
                >
                  {
                    (
                      userLanguage[0].Level3InventoryRecievingTag?.IRTB04 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Grid.Column>{' '}
        </Grid.Row>{' '}
      </Grid>}
    </>
  );
}
export default observer(BarcodeGenerator);
